package com.essntl.features.proposal.ui.addeditproposal

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.invoice.ui.allinvoice.InvoiceEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceState
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.ui.addeditproposal.components.*
import com.essntl.features.proposal.ui.proposalhistory.components.ProposalInvoices
import com.essntl.uikit.components.dialog.EsAlertSaveDialog
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing

@Composable
fun AddEditProposalScreen(
    state: AddEditProposalState,
    onEvent: (AddEditProposalEvent) -> Unit,
    invoiceState: InvoiceState,
    onInvoiceEvent: (InvoiceEvent) -> Unit,
    validation: AddEditProposalValidation,
    onNavigation: (AddEditProposalNavigation) -> Unit,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
    selectedAreaList: List<AreaModel>,
    selectedTabIndex: Int,
) {
    val proposal = state.proposal.value

    val isEdit by remember(proposal) { mutableStateOf(proposal.id.isNotEmpty()) }

    val isLoading = state.isLoading

    LaunchedEffect(state.getProposal.data) {
        validation.addEditProposalForm.reset()
        validation.addEditProposalForm.title.value = state.getProposal.data?.title.orEmpty()
        validation.addEditProposalForm.areas.value = state.getProposal.data?.areas.orEmpty()
        validation.addEditProposalForm.dateRange.firstValue = state.getProposal.data?.fromDate.orEmpty()
        validation.addEditProposalForm.dateRange.secondValue = state.getProposal.data?.toDate.orEmpty()
    }

    Column(
        modifier = Modifier
            .fillMaxWidth(),
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier =
                Modifier
                    .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                    .then(
                        if (isLoading)
                            Modifier.fillMaxSize() else
                            Modifier,
                    ),
        ) {
            if (isLoading)
                EsSpinner()
            else {
                if (!state.isEnabled) {
                    ConfirmedProposalBanner(
                        state = state,
                        onNavigation = onNavigation,
                    )

                    Spacer(modifier = Modifier.height(1.spacing))
                }

                if (selectedTabIndex == 0)
                // Base Information
                    BaseInformation(
                        state = state,
                        onEvent = onEvent,
                        onNavigation = onNavigation,
                        contactState = contactState,
                        contactEvent = contactEvent,
                        isEdit = isEdit,
                        proposal = proposal,
                        selectedAreaList = selectedAreaList,
                        validation = validation,
                        onProposalChange = {
                            onEvent(AddEditProposalEvent.UpdateProposalFields(it))
                        },
                    )
                else if (selectedTabIndex == 1)
                    ClientInformation(
                        state = state,
                        onEvent = onEvent,
                        onNavigation = onNavigation,
                        proposal = proposal,
                    )
                else if (selectedTabIndex == 2)
                    ProposalInvoices(
                        state = invoiceState,
                        onInvoiceEvent = onInvoiceEvent,
                        isAdmin = state.getCurrentProfile.data?.role == ProfileModel.Role.Admin || state.getCurrentProfile.data?.role == ProfileModel.Role.Owner,
                        proposalId = proposal.id,
                        onInvoiceClick = { invoiceId ->
                            onNavigation(
                                AddEditProposalNavigation.EditInvoicing(
                                    invoiceId = invoiceId,
                                    proposalId = proposal.id,
                                ),
                            )
                        },
                        onAddInvoice = {
                            onNavigation(AddEditProposalNavigation.Invoicing)
                        },
                    )

                Spacer(modifier = Modifier.height(1.spacing))
            }
        }

        if (state.openAlertSaveProposalDialog) {
            EsAlertSaveDialog(
                title = "proposal",
                onDismissRequest = {
                    onEvent(AddEditProposalEvent.UpdateAlertSaveProposalDialog(false))
                },
                onReturn = {
                    onNavigation(AddEditProposalNavigation.Back)
                },
            )
        }
    }
}
